import React, { useState, useRef, useEffect } from "react";

const options = [
  "Cricket", "Gaming", "Indoor Games", "Outdoor Games", "Reading",
  "Traveling", "Cooking", "Photography", "Music", "Dancing",
  "Hiking", "Fishing", "Gardening", "Crafting", "Yoga",
  "Meditation", "Cycling", "Running", "Swimming", "Writing",
  "Painting", "Singing", "Acting", "Collecting", "Volunteering",
  "Bird Watching", "Astronomy", "Woodworking", "Knitting", "Sculpting",
  "Martial Arts", "Surfing", "Skiing", "Snowboarding", "Skateboarding",
  "Pottery", "Calligraphy", "Magic", "Puzzles", "Board Games",
  "Card Games", "Baking", "Wine Tasting", "Beer Brewing", "Fitness",
  "Weightlifting", "CrossFit", "Pilates",
  "Anime & Manga", "Cosplay", "Podcasting", "Vlogging", "Blogging",
  "Coding", "Robotics", "3D Printing", "Digital Art", "Graphic Design",
  "Scuba Diving", "Kayaking", "Rock Climbing", "Archery", "Golf",
  "Tennis", "Badminton", "Table Tennis", "Basketball", "Football",
  "Rugby", "Baseball", "Volleyball", "Bowling", "Billiards",
  "Leatherworking", "Sewing", "Crochet", "Origami", "Jewelry Making",
  "Candle Making", "Soap Making", "Scrapbooking", "Model Building", "RC Cars",
  "Stand-up Comedy", "Journaling", "Language Learning", "Public Speaking", "Creative Writing",
  "Historical Reenactment", "Geocaching", "Metal Detecting", "Foraging", "Urban Exploration",
  "Camping", "Backpacking", "Bonsai Tree Care", "Beekeeping", "Aquascaping",
  "Chess", "Fantasy Sports"
];

const MultiSelectHobbies = ({ value = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    if (!value.includes(option)) {
      const newValues = [...value, option];
      onChange?.(newValues);
    }
    setSearchTerm("");
  };

  const handleRemove = (val) => {
    const newValues = value.filter((item) => item !== val);
    onChange?.(newValues);
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
  };

  const filteredOptions = options.filter(
    (opt) =>
      !value.includes(opt) &&
      opt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* Selected values & input */}
      <div
        className="flex flex-wrap items-center w-full px-3 py-2 border rounded-md shadow-sm cursor-text border-gray-300 bg-white"
        onClick={() => setIsOpen(true)}
      >
        {value.map((val) => (
          <span
            key={val}
            className="flex items-center text-sm font-medium mr-2 my-1 bg-blue-100 text-blue-800 rounded-full px-2 py-1"
          >
            {val}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleRemove(val);
              }}
              className="ml-1 text-blue-800 hover:text-blue-900"
            >
              ×
            </button>
          </span>
        ))}
        <input
          type="text"
          placeholder={value.length === 0 ? "Select hobbies..." : ""}
          value={searchTerm}
          onChange={handleInputChange}
          className="flex-grow focus:outline-none border-none bg-transparent placeholder-gray-500"
        />
      </div>

      {/* Dropdown list */}
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <div
                key={opt}
                onClick={() => handleSelect(opt)}
                className="cursor-pointer px-4 py-2 hover:bg-gray-100"
              >
                {opt}
              </div>
            ))
          ) : (
            <div className="px-4 py-2 text-gray-500">No options found.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelectHobbies;
